import { Link, Text, theme } from 'components';
import React, { useContext, useMemo } from 'react';
import { useChannelStateContext, useChatContext } from 'stream-chat-react';
import { getOtherParticipantsFirstNames } from 'utils';
import styled from 'styled-components';
import { ChannelType, ContextualChatContext } from 'contexts';

const ListingCentricActions = () => {
  const { channel } = useChannelStateContext();
  const { client } = useChatContext();
  const { setChatModalVisible } = useContext(ContextualChatContext);

  const { userID } = client;
  const { type } = channel;
  const { listingId, last_message_at: lastMessageAt } = channel.data;

  const channelMembersFirstNames = useMemo(
    () => getOtherParticipantsFirstNames(channel.state.members, userID),
    [channel.state.members, userID],
  );

  return (
    <>
      {/* Only show this if there are no new messages */}
      {type === ChannelType.listing && !lastMessageAt && (
        <StyledContainer>
          <Text
            color={theme.getColor('textSecondary')}
            fontSize={14}
            style={{ textAlign: 'center' }}
          >
            This is the start of your conversation with{' '}
            {channelMembersFirstNames}
          </Text>
          <Link
            href={`#/listing/${listingId}/appointments/book`}
            underlineOnHover
            onClick={() => {
              setChatModalVisible(false);
            }}
          >
            Book a showing
          </Link>
        </StyledContainer>
      )}
    </>
  );
};

const StyledContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  width: 235px;
  flex-wrap: wrap;
  align-self: center;
  align-items: center;
`;

export default ListingCentricActions;
